import type { ButtonHTMLAttributes, PropsWithChildren } from 'react'

type ButtonProps = PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>

function Button({ children, className = '', type = 'button', ...props }: ButtonProps) {
  return (
    <button className={`button ${className}`.trim()} type={type} {...props}>
      {children}
    </button>
  )
}

export function PrimaryButton(props: ButtonProps) {
  return <Button {...props} className={`button--primary ${props.className ?? ''}`} />
}

export function SecondaryButton(props: ButtonProps) {
  return <Button {...props} className={`button--secondary ${props.className ?? ''}`} />
}
